import { theme } from '@noths/polaris-client-ribbons-design-system';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { colors } = theme;

export const PreviewModeContainer = css`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${colors.blueNavy};
  color: ${colors.white};
  padding: ${pxToRem(16)};
  z-index: 999;
`;

export const PreviewModeButton = css`
  position: absolute;
  top: ${pxToRem(8)};
  right: ${pxToRem(16)};
  background-color: ${colors.white};
  text-decoration: none;
  padding: ${pxToRem(8)};
  color: ${colors.blueNavy};
`;
